import { campaignApi, CampaignsUI } from 'features/campaigns'
import { notificationHooks } from 'features/notifications'
import { useNavigate } from 'react-router-dom'
import { useSwitcher } from 'shared/hooks'
import { Button, type ContactsTable, StackIcon } from 'shared/ui'

import css from './CreateCampaign.module.scss'

export function CreateCampaign({
	amount = 0,
	className,
	filters,
	unSelectAll
}: Pick<
	ContactsTable.Types.ActionsProps,
	'amount' | 'filters' | 'unSelectAll'
> & {
	className?: string
}) {
	const switcher = useSwitcher()

	const snack = notificationHooks.useSnack()
	const [create, createOptions] = campaignApi.useCreateCampaignMutation()

	const [addContacts, addContactsProps] =
		campaignApi.useAudienceUpdateMutation()

	const navigate = useNavigate()
	return (
		<>
			<Button
				className={className}
				onClick={switcher.on}
				variant='bordered-dark'
			>
				<span className={css.icon}>
					<StackIcon icon='plus' />
				</span>
				Create campaign
			</Button>

			<CampaignsUI.CreateModal
				amount={amount}
				isLoading={createOptions.isLoading || addContactsProps.isLoading}
				onRequestClose={switcher.off}
				onSubmit={async name => {
					const { data: campaign } = await create(name)

					if (!campaign) {
						return
					}

					snack('3.1')

					await addContacts({
						...filters,
						id: campaign.id
					})
					unSelectAll()
					navigate(`/campaigns/${campaign.id}/tune`)
				}}
				open={switcher.isOn}
			/>
		</>
	)
}
